import * as React from 'react';

import {Button} from '../button/button';
import {SaveButton} from '../button/save-button/save-button';
import {ButtonMover} from '../button-mover/button-mover';
import {ErrorDialog} from '../dialog/error-dialog';
import {FooterBar} from '../modal/footer-bar';

type Props = {
    isSaving: boolean;
    handleSaveFields: () => void;
    onClose: () => void;
    errorMessage?: string;
};

export function CustomizeFieldsFooter(props: Props) {
    const [showError, setShowError] = React.useState<boolean>(true);
    const buttonRef = React.useRef(null);

    return (
        <FooterBar
            left={
                <ButtonMover size='big' direction='left'>
                    <Button variant='text' size='big' onClick={props.onClose}>
                        Cancel
                    </Button>
                </ButtonMover>
            }
            right={
                <>
                    <SaveButton
                        isSaving={props.isSaving}
                        // @ts-expect-error
                        onClick={props.handleSaveFields}
                        savingText='Saving…'
                        buttonText='Save & update'
                        getButtonRef={buttonRef}
                        disabled={Boolean(props.errorMessage)}
                    />
                    {showError && props.errorMessage ? (
                        <ErrorDialog
                            anchor={buttonRef.current}
                            location='top'
                            message={props.errorMessage}
                            onClose={() => setShowError(false)}
                        />
                    ) : undefined}
                </>
            }
        />
    );
}
